import { useRiskWire } from "../__consumer/useRiskWire/useRiskWire.data";
import { GenericIndexComparison } from "./types.old";
import { ITimePeriod } from "@iliotech/types";
import moment from "moment";

const formatDate = (description: string, s?: string) =>
  !s ? "" : `${description} ${moment(s).format("DD MMM YYYY")}`;

export const riskVolatilityFormatterV1 = (
  volatilityResponseData: ReturnType<
    typeof useRiskWire
  >["serverData"]["volatilityResponse"]["data"],
  period?: ITimePeriod
) => {
  const staticVolatilityData: GenericIndexComparison[] = [
    {
      name: !!period
        ? `Volatility ${formatDate("from", period?.from)} ${formatDate(
            "to",
            period?.to
          )} (Annualised)`
        : `Annual Volatility`,
      key: "annualVolatility",
      value: {
        value: volatilityResponseData?.data.portfolio?.volatility ?? -1,
        displayValue:
          (
            volatilityResponseData?.data?.portfolio?.volatility ?? -1
          ).toLocaleString(undefined, {
            maximumFractionDigits: 1,
            minimumFractionDigits: 1,
          }) ?? "",
        type: "NeutralNumber",
        suffix: "%",
      },
      indexValue: {
        value: volatilityResponseData?.data?.benchmark?.volatility ?? -1,
        displayValue:
          (
            volatilityResponseData?.data?.benchmark?.volatility ?? -1
          ).toLocaleString(undefined, {
            maximumFractionDigits: 1,
            minimumFractionDigits: 1,
          }) ?? "",
        type: "NeutralNumber",
        suffix: "%",
      },
    },
    {
      name: `Sharpe Ratio (Based on avg. annual return)`,
      key: "sharpeRatio",
      value: {
        value: volatilityResponseData?.data?.portfolio?.sharpeRatio ?? -1,
        type: "RedWhenNegative",
        suffix: "",
      },
      indexValue: {
        value: volatilityResponseData?.data?.benchmark?.sharpeRatio ?? -1,
        type: "RedWhenNegative",
        suffix: "",
      },
    },
    {
      name: `1 Yr Rolling Beta (Daily Sampling)`,
      key: "oneYearRollingBeta",
      value: {
        value: Number(volatilityResponseData?.data?.portfolio?.beta ?? -1),
        displayValue:
          (volatilityResponseData?.data?.portfolio?.beta ?? -1).toLocaleString(
            undefined,
            {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            }
          ) ?? "",
        type: "RedWhenNegative",
        suffix: "",
      },
      indexValue: {
        value: Number(volatilityResponseData?.data?.benchmark?.beta ?? -1),
        displayValue:
          (volatilityResponseData?.data?.benchmark?.beta ?? -1).toLocaleString(
            undefined,
            {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            }
          ) ?? "",
        type: "RedWhenNegative",
        suffix: "",
      },
    },
    {
      name: `Outperformance vs ${volatilityResponseData?.data?.benchmark?.indexName}`,
      key: "ouperformanceVsBenchmarkIndex",
      value: {
        value: volatilityResponseData?.data?.portfolio?.statistics?.alpha ?? -1,
        type: "RedWhenNegative",
        suffix: "%",
      },
      indexValue: {
        value: volatilityResponseData?.data?.benchmark?.statistics?.alpha ?? -1,
        type: "RedWhenNegative",
        suffix: "%",
      },
    },
  ];

  return staticVolatilityData;
};
